import { request } from '../request';

export async function getShift(shiftId: string) {
  if (shiftId.startsWith('shiftrotation-')) {
    return getShiftRotation(shiftId);
  }
  if (shiftId.startsWith('shiftseries-')) {
    return getShiftSeries(shiftId);
  }
  throw new Error('TBD: request for the single shift is not implemented');
}
export async function getShiftSeries(shiftId: string) {
  // id: shiftseries-00000000000000000000000000
  const response = await request.get<ShiftRotationResponse>(`/v2/shift-series/${shiftId}`);

  return response.data;
}

export async function getShiftRotation(shiftId: string) {
  // id: shiftrotation-00000000000000000000000000
  const response = await request.get<ShiftSeriesResponse>(`/v2/shift-rotations/${shiftId}`);
  return response.data;
}

type ShiftRotationResponse = ShiftPeriodicResponse;
type ShiftSeriesResponse = ShiftPeriodicResponse;
type ShiftPeriodicResponse = {
  id: string;
  externalId: string;
  agencyIdsForShare: string[] | null;
  isArchive: boolean;
  isShared: boolean;
  isAssigned: boolean;
  staffNurseQualificationFilters: {
    id: string;
    name: string;
    abbreviation: string;
    category: string;
  }[];
  assignRequest: {
    status: 'Pending' | 'Approved' | 'Declined';
    staff: {
      id: string; // 'staffmember-00000000000000000000000000';
      firstName: string;
      lastName: string;
      fullName: string;
      imageUrl: string;
    };
    declineReason: string;
  } | null;
  staff: {
    id: string;
    firstName: string;
    lastName: string;
    imageURL: string;
    nurseQualifications: {
      id: string;
      name: string;
      abbreviation: string;
      category: string;
    }[];
  }[];
  startDate: {
    dateTime: string;
    timeZone: string;
  };
  endDate: {
    dateTime: string;
    timeZone: string;
  };
  department: {
    label: string;
  };
  subDepartment: {
    label: string;
  } | null;
  speciality: {
    id: string;
    title: string;
    category: string;
  };
  events: {
    id: string;
    externalId: string;
    startDate: {
      dateTime: string;
      timeZone: string;
    };
    endDate: {
      dateTime: string;
      timeZone: string;
    };
    status: Status;
    staff: {
      id: string;
      firstName: string;
      lastName: string;
      imageURL: string;
      nurseQualifications: {
        id: string;
        name: string;
        abbreviation: string;
        category: string;
      }[];
    } | null;
  }[];
  locationId: string;
  tags: string[] | null;
  note: string | null;
  canHasMultipleAssignee: boolean;
  canAssign: boolean;
  canUnassign: boolean;
  isArchived: boolean;
  isUrgent: boolean;
};

type Status =
  | 'Opened'
  | 'Pending'
  | 'Assigned'
  | 'Reassigned'
  | 'Canceled'
  | 'InProgress'
  | 'Unfilled'
  | 'Deleted'
  | 'Expired'
  | 'Unassigned'
  | 'Completed';
